import React from 'react';
import './HtmlContent.style.css';
import DOMPurify from 'dompurify';
import 'react-quill/dist/quill.snow.css';

const HtmlContent = ({ content, style }) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <div
      className="ql-editor"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(content, {
          ADD_TAGS: ['iframe'],
          ADD_ATTR: [
            'allow',
            'allowFullScreen',
            'frameborder',
            'scrolling',
            'src',
          ],
        }),
      }}
      style={{ ...style }}
    />
  );
};

export default HtmlContent;
